import _ from "lodash";
import moment, { Moment } from "moment";
import {
  IFilterCategory,
  ISearchVehicle as IVehicle,
  IVehicleShort,
  IVehicleType,
} from "../interface";

interface VehicheInterface {
  yearFrom: number;
  yearTo: number | null;
}

const getYearAry = (m: VehicheInterface[]) => {
  return _.map(m, (v) => [
    moment(v["yearFrom"], "YYYY"),
    !_.isNull(v["yearTo"]) ? moment(v["yearTo"], "YYYY") : moment(),
  ]);
};

const iterationYear = (result: Moment[], value: Moment[]) => {
  if (_.isEmpty(result)) {
    result = value;
    return result;
  }
  if (result[0].isAfter(value[0])) {
    result[0] = value[0];
  }
  if (result[1].isBefore(value[1])) {
    result[1] = value[1];
  }
  return result;
};

const getDaysBetweenDates = (range: Moment[]) => {
  const dates = [];
  if (!_.isEmpty(range)) {
    const now = range[0].clone();

    while (now.isSameOrBefore(range[1])) {
      dates.push(now.format("YYYY"));
      now.add(1, "years");
    }
  }
  return dates;
};

const analyseData = {
  vehicleType: (vehicleTypes: IVehicleType[]) => {
    return _.chain(vehicleTypes)
      .map((v) => v.name)
      .uniq()
      .value();
  },
  make: (vehicleTypes: IVehicleType[], vehicleType: string) => {
    if (_.isEmpty(vehicleTypes)) {
      return [];
    }
    return _.chain(vehicleTypes)
      .cloneDeep()
      .find(["name", vehicleType])
      .thru((d) => d["make"])
      .thru((d) => _.map(d, "name"))
      .value();
  },
  model: (vehicleTypes: IVehicleType[], vehicleType: string, make: string) => {
    if (_.isEmpty(make)) {
      const result = _.chain(vehicleTypes)
        .filter((item) => _.isEmpty(vehicleType) || item.name === vehicleType)
        .map((v) => _.map(v["make"], (item) => item["model"]))
        .value();
      return _.uniq(_.flatMapDeep(result));
    } else {
      const result = _.chain(vehicleTypes)
        .filter((item) => _.isEmpty(vehicleType) || item.name === vehicleType)
        .map((v) =>
          _.map(v["make"], (item) => {
            if (_.isEqual(item["name"], make)) {
              return item["model"];
            } else {
              return [];
            }
          })
        )
        .value();
      return _.uniq(_.flatMapDeep(result));
    }
  },
  year: (models: IVehicleShort[]) => {
    const yearsAry = getYearAry(models);
    const range = _.reduce(yearsAry, iterationYear, []);
    return getDaysBetweenDates(range);
  },
  vehicleTypeFormat: (vehicles: IVehicle[]) => {
    return _.chain(vehicles)
      .map((v) => v.vehicleType)
      .uniq()
      .map((v) => {
        return { name: v };
      })
      .thru((v) => {
        return _.chain(v)
          .map((vehicleItem) =>
            _.update(vehicleItem, "make", () => {
              return _.chain(vehicles)
                .filter(["vehicleType", vehicleItem["name"]])
                .map((v) => v.make)
                .uniq()
                .map((v) => {
                  return { name: v };
                })
                .thru((v) => {
                  return _.chain(v)
                    .map((_v) =>
                      _.update(_v, "model", () => {
                        return _.chain(vehicles)
                          .filter(["vehicleType", vehicleItem["name"]])
                          .filter(["make", _v["name"]])
                          .map((v) => v.model)
                          .uniq()
                          .value();
                      })
                    )
                    .value();
                })
                .value();
            })
          )
          .value();
      })
      .value();
  },
  getMake: (vehicleTypes: IVehicleType[]) => {
    return _.chain(vehicleTypes)
      .reduce((result: string[], vehicleType) => {
        const makes = vehicleType["make"];
        const r = _.chain(makes)
          .reduce((_result: string[], make) => {
            return _.concat(_result, make["name"]);
          }, [])
          .value();
        return _.concat(result, r);
      }, [])
      .uniq()
      .value();
  },
  getYear: (vehicles: IVehicle[]) => {
    const yearsAry = getYearAry(vehicles);
    const range = _.reduce(yearsAry, iterationYear, []);
    return getDaysBetweenDates(range);
  },
  getValues: (categories: IFilterCategory[], isSorting = false) => {
    if(!categories) {
      return categories;
    }
    const values = categories.map((item) => item.id);
    // Sort the values in ascending order 
    isSorting && values.sort();
    return values;
  },
};

export default analyseData;